import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpRequestMethods, IDP_APPS } from '../../constants/utils';
import {
  EndpointKeysCommon,
  EndpointKeysHeader,
  HEADER_FEATURES
} from '../../constants/utils/app.constants';
import {
  CityCodeResult,
  RetrieveSearch
} from '../../models/search-flights/retrieve-search.interface';
import { ApiBuilder, AppConfigService, LoggingService } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class RetrieveSearchService {
  constructor(
    private appConfig: AppConfigService,
    private logging: LoggingService,
    private http: HttpClient
  ) {}

  retrieveSearch$!: Observable<RetrieveSearch[]>;
  retrieveSearchDeepLink$!: Observable<RetrieveSearch[]>;

  getRetrieveSearchContent$(): Observable<RetrieveSearch[]> {
    if (this.retrieveSearch$) {
      return this.retrieveSearch$;
    } else {
      this.retrieveSearch$ = this.getRetrieveSearchContent().pipe(
        shareReplay(1)
      );

      return this.retrieveSearch$;
    }
  }

  getRetrieveSearchContent(): Observable<RetrieveSearch[]> {
    return new ApiBuilder<string, RetrieveSearch[]>(this.http, this.appConfig)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon['APP_SESS_CUSTOMER_GETPREFILL_URL'])
      .queryParams(`RecentSearchesJSON&cacheBustParam=${new Date().valueOf()}`)
      .method(HttpRequestMethods['GET'])
      .errorHandler(this._handleError.bind(this))
      .library(HEADER_FEATURES.SEARCH_FLIGHTS)
      .create();
  }

  getRetrieveSearchDeepLinkContent$(
    payload: string
  ): Observable<RetrieveSearch[]> {
    if (this.retrieveSearchDeepLink$) {
      return this.retrieveSearchDeepLink$;
    } else {
      this.retrieveSearchDeepLink$ = this.getRetrieveSearchDeepLinkContent(
        payload
      ).pipe(shareReplay(1));

      return this.retrieveSearchDeepLink$;
    }
  }

  private getRetrieveSearchDeepLinkContent(
    payload: string
  ): Observable<RetrieveSearch[]> {
    return new ApiBuilder<string, RetrieveSearch[]>(this.http, this.appConfig)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon['APP_SESS_CUSTOMER_GETPREFILL_URL'])
      .method(HttpRequestMethods['GET'])
      .queryParams(payload)
      .errorHandler(this._handleError.bind(this))
      .library(HEADER_FEATURES.SEARCH_FLIGHTS)
      .create();
  }

  postRecentSearchesForDeepLink(
    payload: RetrieveSearch,
    queryParams: string
  ): Observable<RetrieveSearch[]> {
    return new ApiBuilder<RetrieveSearch, RetrieveSearch[]>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon['APP_SESS_CUSTOMER_GETPREFILL_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .queryParams(queryParams)
      .errorHandler(this._handleError.bind(this))
      .library(HEADER_FEATURES.SEARCH_FLIGHTS)
      .create();
  }

  getPredictiveCities(payload: string): Observable<CityCodeResult[]> {
    return (
      new ApiBuilder<string, CityCodeResult[]>(this.http, this.appConfig)
        .app(IDP_APPS.HEADER)
        .endpointKey(EndpointKeysHeader['APP_NEW_PREDICTIVE_API_URL'])
        .method(HttpRequestMethods['GET'])
        .queryParams(payload)
        .errorHandler(this._handleError.bind(this))
        .library(HEADER_FEATURES.SEARCH_FLIGHTS)
        .retries(2)
        //adding 30 sec timout before triggering ref api call
        //as discussed
        .timeOut(30000)
        .create()
    );
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
